import(/* webpackMode: "eager", webpackExports: ["MyEsimWebPage"] */ "/opt/buildhome/repo/src/app/[lng]/(main)/_account-web/personal-web.tsx");
